import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from 'react-apollo';
import csc from 'country-state-city';
import CSVReader from 'react-csv-reader'
import { routeConstants, history, handleGraphqlError, staticConstants, NUMERIC_VALUE } from '../../../../utils';
import { CREATE_USERS, LOADER_MUTATION } from '../../../../graphql-client/mutations';

import {
  Form, FormGroup
} from 'reactstrap';
import moment from 'moment';
import InputError from '../../../shared/elments/InputError';
import { useScrollToError } from '../../../../hooks/useScrollToError';

const csvColumnArtistHeadersByOrder = [
    "name",
    "country",
    "state",
    "city",
    "genre",
    "bio",
    "primaryContactName",
    "email",
    "contactNumber",
    "shippingAddress",
    "image",
    "instagram",
    "facebook",
    "spotify",
    "youtube",
    "twitter",
    "website"
];

const csvColumnManagerHeadersByOrder = [
  "name",
  "managerFirstName",
  "managerLastName",
  "country",
  "state",
  "city",
  "genre",
  "bio",
  "primaryContactName",
  "email",
  "companyName",
  "contactNumber",
  "shippingAddress",
  "artistImage",
  "managerImage",
  "instagram",
  "facebook",
  "spotify",
  "youtube",
  "twitter",
  "website"
];


function CreateUser(props) {
  // constants
  const location = useLocation();
  const { addToast } = useToasts();
  const countryOptions = csc.getAllCountries();
  const countryLabels = countryOptions.map((country) => ({
    label: country.name,
    value: country.id,
  }));
  const {
    handleSubmit, errors,
  } = useForm({ mode: 'onBlur', nativeValidation: false });
  useScrollToError(errors);

  useEffect(() => {
    document.body.classList.add('bg-grey');
  }, []);

  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: header =>
      header
        .replace(/\W/g, '_')
  }

  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: { show: false },
  });

  const [createUsersAccount] = useMutation(CREATE_USERS, {
    variables: {},
    onError(error) {
      loaderMutate({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },

    onCompleted(data) {
      loaderMutate({ variables: { show: false } });
      addToast(data.importUsers.message, { appearance: 'success' });
    },
  });

  const clean = (obj) => {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj
  }


  const getStateValue = (country, state) => {
    const states = csc.getStatesOfCountry(country)
    const filterStates = states.filter((s) => s.name === state);
    let obj = {}
    if (filterStates.length > 0) {
      const state = filterStates[0];
      obj = {
        label: state.name,
        value: state.id,
      }
    }
    return obj;
  }

  const getCityValue = (state, city) => {
    const cities = csc.getCitiesOfState(state)
    const filterCities = cities.filter((c) => c.name === city);
    let obj = {}
    if (filterCities.length > 0) {
      const city = filterCities[0];
      obj = {
        label: city.name,
        value: city.id,
      }
    }
    return obj;
  }

  const getCompleteData = (obj, data) => {
    return {
      country: obj.country ? obj.country : { label: data.country ? data.country : '', value: '' },
      state: obj.state ? obj.state : { label: data.state ? data.state : '', value: '' },
      city: obj.city ? obj.city : { label: data.city ? data.city : '', value: '' },
      isError: obj.isError
    }
  }

  const getRegion = (country, state, city) => {
    let obj = {};
    const filterCountryLabels = countryLabels.filter((c) => c.label === country);
    if (filterCountryLabels.length > 0) {
      const countryLabel = filterCountryLabels[0];
      obj.country = countryLabel;
      const stateValue = getStateValue(countryLabel.value, state);
      if (Object.keys(stateValue).length > 0) {
        obj.state = stateValue;
        const cityValue = getCityValue(stateValue.value, city);
        if (Object.keys(cityValue).length > 0) {
          obj.city = cityValue;
        }
      }
    }
    if (Object.keys(obj).length !== NUMERIC_VALUE.THREE) {
      obj.isError = true
    }
    return getCompleteData(obj, {
      country,
      state,
      city
    });
  }

  const onSubmit = (data, fileInfo) => {
    let csvColumnHeadersByOrder = csvColumnManagerHeadersByOrder;
    if(location.pathname === routeConstants.IMPORT_ARTIST) {
      csvColumnHeadersByOrder = csvColumnArtistHeadersByOrder;
    }
    const updatedData = data.map((d) => {
       const {country, state, city} = d;
       let regions = getRegion(country, state, city);
       if (d.labelFirstName) {
        d.managerFirstName = d.labelFirstName;
      }
      if (d.labelImage) {
        d.managerImage = d.labelImage;
      }
      if (d.labelLastName) {
        d.managerLastName = d.labelLastName;
      }
      delete d.labelFirstName;
      delete d.labelImage;
      delete d.labelLastName;
       if(location.pathname === routeConstants.IMPORT_ARTIST) {
          delete d.managerFirstName;
          delete d.managerLastName;
          delete d.managerImage;
       }
       return clean({
        ...d,
        country: regions.country,
        state: regions.state,
        city: regions.city,
        isErrorRegion: regions.isError ? true : false,
        contactNumber: d.contactNumber.toString(),
        socialMedia: {
          instagram: d.instagram === null ? '' : d.instagram,
          facebook: d.facebook === null ? '' : d.facebook,
          twitter: d.twitter === null ? '' : d.twitter,
          website: d.website === null ? '' : d.website,
          spotify: d.spotify === null ? '' : d.spotify,
          youtube: d.youtube === null ? '' : d.youtube
        },
        instagram: undefined,
        facebook: undefined,
        twitter: undefined,
        website: undefined,
        spotify: undefined,
        youtube: undefined
      });
    })
    loaderMutate({ variables: { show: true } });
    createUsersAccount({
      variables: {
        users: updatedData,
        columnOrder: csvColumnHeadersByOrder.join(','),
        role: location.pathname === routeConstants.IMPORT_ARTIST ? staticConstants.ROLE.ARTIST : staticConstants.ROLE.MANAGER
      }
    });
  };

  const handleBackButton = () => {
    document.body.classList.remove('bg-grey');
    history.goBack();
  };


  return (
    <>
      <Form className="create-offer" onSubmit={handleSubmit(onSubmit)}>
        <div className="create-offer-head">
          <div className="create-offer-head-container">
            <div onClick={() => handleBackButton()} className="create-offer-head-back-btn cursor-pointer">
              <span className="icon icon-next rotate-180" />
              Back
            </div>
          </div>
        </div>
        <div className="create-offer-content">
          <div className="create-offer-content-container">
            <div className="create-offer-detail" style={{ 'width': '100%' }}>
              <h2>
                <span>
                  Import
                  {' '}
                  {location.pathname === routeConstants.IMPORT_ARTIST ? 'Artists' : 'Labels'}
                </span>
              </h2>
              <div className="create-offer-detail-wrapper upload-csv-wrapper">
                <FormGroup className={`upload-wrapper mb-0 w-100 ${errors.clientLogoUpload ? 'image-error' : ''}`}>
                  <div className="image-upload-button lg">
                    <span>
                      <CSVReader
                        onFileLoaded={onSubmit}
                        label='Upload CSV'
                        parserOptions={papaparseOptions}
                        cssInputClass=''
                      />
                    </span>
                  </div>
                  <div className="csv-sample-file-btn">
                    { location.pathname === routeConstants.IMPORT_ARTIST
                      ? <a className="btn btn-primary" href="/artist_sample.csv">Download Sample File</a>
                      : <a className="btn btn-primary" href="/label_sample.csv">Download Sample File</a> }
                  </div>
                  <InputError error={errors.coverImageUpload} />
                </FormGroup>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default CreateUser;
